<template>
  <div class="scs-editable-field">
    <p class="editable-field-heading">{{ title }}</p>
    <round-button-with-icon icon="spinner" v-if="processing" />
    <p class="field-value" v-if="!editing && !processing" @click="toggleEdit()">
      {{ display }}
    </p>
    <Input
      v-if="editing && inputType === 'text' && !processing"
      :placeholder="value"
      @scs-blur="toggleEdit"
      @scs-input="input"
      class="editable-field-input"
    />
    <date-picker
      v-if="editing && inputType === 'date' && !processing"
      :initialValue="value"
      @close="toggleEdit"
    />
    <time-picker
      v-if="editing && inputType === 'time' && !processing"
      :initialValue="value"
      @close="toggleEdit"
    />
  </div>
</template>
<script>
import Input from "../Elements/Input.vue";
import RoundButtonWithIcon from "./RoundButtonWithIcon.vue";
import DatePicker from "./FloatingCards/Shared/DatePickerCard.vue";
import TimePicker from "./FloatingCards/Shared/TimePickerCard.vue";
export default {
  data() {
    return {
      editing: false,
    };
  },
  computed: {
    display() {
      if (this.formatter) {
        if (!this.value) {
          return "undefined";
        }
        return this.formatter(this.value);
      } else {
        if (!this.value) {
          return "undefined";
        }
        return this.value;
      }
    },
  },
  methods: {
    toggleEdit(val) {
      if (val) {
        this.input(val);
      }
      if (this.editing) {
        this.$emit("scs-blur");
        this.editing = false;
      } else {
        this.editing = true;
      }
    },
    input(val) {
      this.$emit("scs-input", val);
    },
  },
  created() {},
  components: { Input, TimePicker, DatePicker, RoundButtonWithIcon },
  emits: ["scs-input", "scs-blur"],
  props: ["inputType", "title", "value", "formatter", "processing"],
};
</script>
<style scoped>
.scs-editable-field {
  height: 80px;
  width: 150px;
}
p {
  font-size: 0.7rem;
  text-align: left;
  overflow-wrap: break-word;
}

.field-value {
  cursor: pointer;
  font-weight: 600;
}

.editable-field-input {
  width: 80%;
}
</style>
